import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { Document } from '@app/core/model/entities/document/document';
import { Entity, IRelatedEntity, RelatedEntity } from '@app/core/model/entities/entity';
import { Expose, Type } from 'class-transformer';

export class AssetGroup extends Entity {
  public objectType = EntityTypeEnum.ASSET;

  public identifier: number;
  public organizationId: string;
  public dataDate: string;

  @Type(() => Document) public documents: Document[] = [];

  @Expose()
  public toString(): string {
    return this.computedProperties?.['displayName'] ?? `${this?.identifier} - ${this?.name}`;
  }

  /**
   * Transforms this Asset Group to a RelatedAssetGroup.
   */
  public toRelatedAssetGroup(): RelatedAssetGroup {
    return new RelatedAssetGroup({
      id: this.id,
      name: this.name,
      identifier: this.identifier,
      displayName: this.computedProperties?.['displayName']
    });
  }
}

export interface AssetGroupInput {
  name?: string;
  properties?: Record<string, any>;
}

export type IRelatedAssetGroup = IRelatedEntity;

export class RelatedAssetGroup extends RelatedEntity implements IRelatedAssetGroup {
  constructor(relatedAssetGroup: IRelatedAssetGroup) {
    super(relatedAssetGroup);
  }
}
